import React from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";
import { useNavigate } from "react-router-dom";

interface PlanPurchasePageHeaderProps {
  mode: "upgrade" | "addon_only" | "renew";
}
const PlanPurchasePageHeader: React.FC<PlanPurchasePageHeaderProps> = ({
  mode,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (mode === "renew") {
      navigate("/pricing", { replace: true });
      return;
    }

    if (mode === "addon_only") {
      navigate("/", { replace: true });
      return;
    }

    navigate("/accounts", { replace: true });
  };

  const getTitle = () => {
    if (mode === "addon_only") {
      return "Addon Plan Purchase";
    } else if (mode === "renew") {
      return "Renew Plan";
    } else {
      return "Subscription Plan Purchase";
    }
  };

  return (
    <div className="dashboard-page-title">
      <Button
        onClick={handleBack}
        type="text"
        size="middle"
        icon={<ArrowLeftOutlined style={{ fontSize: "20px" }} />}
      />

      <Typography.Title level={4} style={{ margin: 0 }}>
        {getTitle()}
      </Typography.Title>
    </div>
  );
};

export default PlanPurchasePageHeader;
